module.exports = __webpack_public_path__ + "img/excel.29b19ee8.png";